export default "__VITE_ASSET__XcxUVurR__"